         // Direct  Checkout Button Code
$(document).ready(function() {
  setTimeout(function() {
  $('.add-to-cart-checkout').click(function(e){
    setTimeout(function(){
      window.location.href = '/checkout';
    },1000);
  });
 $('.main_image_product_featuerd').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
   fade: true,
   draggable: false,
   swipe: false,
   swipeToSlide: false,
   asNavFor: '.thumbnail_product_image',
       prevArrow:'<div class="arrow-left product-arrows"><svg  viewBox="0 0 14 10"  fill="none"  aria-hidden="true"  focusable="false"  class="icon icon-arrow"  xmlns="http://www.w3.org/2000/svg">  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></svg></div>',
    nextArrow:'<div class="arrow-right product-arrows"><svg  viewBox="0 0 14 10"  fill="none"  aria-hidden="true"  focusable="false"  class="icon icon-arrow"  xmlns="http://www.w3.org/2000/svg">  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></svg></div>'
 });
 $('.thumbnail_product_image').slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   asNavFor: '.main_image_product_featuerd',
   dots: false,
   focusOnSelect: true,
   arrows:false,
   draggable: false,
     swipeToSlide: false,
   swipe: false
 });

$('.review-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
     prevArrow:'<div class="arrow-left product-arrows"><svg  viewBox="0 0 14 10"  fill="none"  aria-hidden="true"  focusable="false"  class="icon icon-arrow"  xmlns="http://www.w3.org/2000/svg">  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></svg></div>',
    nextArrow:'<div class="arrow-right product-arrows"><svg  viewBox="0 0 14 10"  fill="none"  aria-hidden="true"  focusable="false"  class="icon icon-arrow"  xmlns="http://www.w3.org/2000/svg">  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></svg></div>'
});

     // Product Images Variant Change Code

$('.product-form__input label').click(function(){
    var variantImgSrc = $(this).attr('img');
    console.log(variantImgSrc);
  
    var targetThumbnail = $('.thumbnails_image[data-src="' + variantImgSrc + '"]');
  targetThumbnail.each(function(){
    this.click();
})
  
});

$(window).resize(function(){
  if ($(window).width() < 990) {
    VideoSlider();
  }
});
if ($(window).width() < 990) {
    VideoSlider();
  }

       function VideoSlider(){
         $('.section_grid_video').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
   prevArrow:'<button class="slick-prev video_slider_btn large_up_hide pull-left"><svg style="rotate:180deg" viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></button>',
            nextArrow:'<button class="slick-next video_slider_btn large_up_hide pull-right"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

       }
       },2000);
  
       });
